import {getLocalData, setLocalData} from "./StorageServices"

const _store = {
    state: {
        accessToken: getLocalData('accessToken', ''),
        refreshToken: getLocalData('refreshToken', ''),
        apiKey: getLocalData('apiKey', ''),
        user: getLocalData('user', {}),
        error: '',
    },
    subscribers: []
}

const _broadcast = () => {
    setTimeout(() => {
        _store.subscribers.forEach(subscriber => {
            subscriber(_store.state)
        })
    }, 0)
}

export const subscribe = subscriber => {
    if (typeof subscriber !== 'function') return
    if (_store.subscribers.indexOf(subscriber) !== -1) return

    _store.subscribers = [].concat(_store.subscribers, subscriber)
}

export const unsubscribe = subscriber => {
    _store.subscribers = _store.subscribers.filter(sub => sub !== subscriber)
}

export const isAuthenticated = () => {
    const {state} = _store

    return !!state.accessToken && !!state.apiKey
}

export const setUserData = user => {
    const updatedUser = user

    _store.state = {
        ..._store.state,
        user: updatedUser
    }

    setLocalData('user', updatedUser)
    _broadcast()
}

export const getUserData = () => getLocalData('user') || _store.state.user || {}

export const setAccessToken = (accessToken, apiKey) => {
    _store.state = {
        ..._store.state,
        accessToken,
        apiKey
    }

    setLocalData('accessToken', accessToken)
}

export const setRefreshToken = refreshToken => {
    _store.state = {
        ..._store.state,
        refreshToken,
    }

    setLocalData('refreshToken', refreshToken)
}

export const getAccessToken = () => getLocalData('accessToken') || _store.state.accessToken || ''

export const getRefreshToken = () => getLocalData('refreshToken') || _store.state.refreshToken || ''

export const getErrorMessage = () => _store.state.error || ''

export const logoutUser = (message = '') => {
    _store.state.error = message || ''

    setAccessToken('', '')
    setRefreshToken('')
    setUserData({})
    _broadcast()

    return true
}
